import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IEmbed, IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '.';
import { PrismicEmbed, PrismicImage, PrismicLink } from '../utils/PrismicTypes';
import { parseEmbed, parseImage, parseLink, parseRichText, parseString } from '../utils/parsers';

export interface IHero extends IBaseSlice {
  tagline: string;
  title: string;
  text: RichTextBlock[];
  linkText: string;
  link: ILink;
  image: IImage;
  video: ILink;
  embed: IEmbed;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
        slice_text
        slice_link_text
        slice_link { ...Link }
        slice_image
        slice_video { ...Link }
        slice_embed
      }
    }
  }
`;

type Props = {
  primary: {
    slice_tagline: RichTextBlock[];
    slice_title: RichTextBlock[];
    slice_text: RichTextBlock[];
    slice_link_text: RichTextBlock[];
    slice_link: PrismicLink;
    slice_image: PrismicImage;
    slice_video: PrismicLink;
    slice_embed: PrismicEmbed;
  };
};

export const parse = (slice: Props, redirects): IHero => ({
  type: SliceTypes.Hero,
  tagline: parseString(slice.primary.slice_tagline),
  title: parseString(slice.primary.slice_title),
  text: parseRichText(slice.primary.slice_text, redirects),
  linkText: parseString(slice.primary.slice_link_text),
  link: parseLink(slice.primary.slice_link, redirects),
  image: parseImage(slice.primary.slice_image),
  video: parseLink(slice.primary.slice_video),
  embed: parseEmbed(slice.primary.slice_embed),
});
